import React from 'react'

const FeedTrim = () => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="trim">
        <rect className="holder" stroke="#121212" x="0.5" y="0.5" width="19" height="19" rx="2" />
        <rect className="thumb" fill="#121212" x="0" y="6" width="20" height="8" rx="2" />
      </g>
    </g>
  </svg>
)

export default FeedTrim
